import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'


const url = 'v1/whats-new'
const plural = 'whats-news'
const single = 'whats-new'

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})


api.getWhatsNew = (payload) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`,payload)
		.then(handleResponse)
		.catch(handleError);
}

api.updateUserWhatsNewId = (payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/seen`,payload)
		.then(handleResponse)
		.catch(handleError);
}

export default api
